import { AxiosPromise } from 'axios';
import { logout } from 'src/actions/authentication/login/Login.actions';
import { store } from 'src/store';
import { TypedResource } from 'src/services/api-client/resource/base/TypedResource';
import ProjectTeamMember from 'src/value-objects/ProjectTeamMembers';

export default class ProjectTeamMemberResource extends TypedResource<ProjectTeamMember> {
  constructor() {
    super('/projects/:projectId/team-members', ProjectTeamMember);
  }

  public delete(projectId: string, teamMemberId: string): AxiosPromise {
    this.getHeaders();

    const url: string = '/projects/' + projectId + '/team-members/' + teamMemberId;

    return this.httpClient
      .delete(url)
      .catch((errorResponse) => {
        if (errorResponse.response.data.message.includes('Unauthenticated')) {
          store.dispatch(logout());
        }
        throw errorResponse;
      });
  }
}



// WEBPACK FOOTER //
// ./src/services/api-client/resource/ProjectTeamMemberResource.tsx